<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <p-tabMenu
    [model]="tabItems"
    [activeItem]="activeTabItem"
    (activeItemChange)="onTabChange($event)">
  </p-tabMenu>
  @if (selectedTab === 'general') {
    <div class="grid">
      <app-form-field-wrapper
        [label]="'Name'"
        [name]="'title'"
        [colSize]="7"
        [formField]="form.get('title')">
        <input
          pInputText
          id="title"
          type="text"
          formControlName="title"
          class="p-input" />
      </app-form-field-wrapper>
    </div>
    <div class="grid">
      <app-icon-dropdown
        [formField]="form.get('icon')"
        [colSize]="2"
        [mode]="'fa'"
        formControlName="icon"
        label="Icon"
        name="icon"></app-icon-dropdown>
      <app-form-field-wrapper
        [label]="'öffentlich sichtbar'"
        [name]="'published'"
        [colSize]="4">
        <p-inputSwitch formControlName="published"></p-inputSwitch>
      </app-form-field-wrapper>
    </div>
    <div class="grid">
      <app-form-field-wrapper
        [label]="'Beschreibung'"
        [floatingLabel]="false"
        [name]="'description'">
        <p-editor formControlName="description" [style]="{ height: '50px' }">
          <ng-template pTemplate="header">
            <span class="ql-formats">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
              <button type="button" class="ql-link" aria-label="Link"></button>
            </span>
          </ng-template>
        </p-editor>
      </app-form-field-wrapper>
    </div>
    <p-divider />
    <div class="grid">
      <app-workspace-dropdown
        name="workspaces"
        type="topic"
        formControlName="workspaces"></app-workspace-dropdown>
    </div>
  } @else if (selectedTab === 'lesezeichen') {
    <div class="grid">
      <app-bookmark-dropdown
        [selection]="form.value.defaultBookmark"
        label="Startansicht ist..."
        formControlName="defaultBookmark"></app-bookmark-dropdown>
    </div>

    <app-header
      text="Themenbereiche"
      icon="fas fa-layer-group"
      sub="Hier können Sie dem Thema Themenbereiche zuordnen, die als Navigation dienen sollen."></app-header>

    <p-pickList
      [showSourceControls]="false"
      [dragdrop]="true"
      [filterBy]="bookmarkCategories.length > 10 ? 'title' : undefined"
      [sourceStyle]="{ height: '30rem' }"
      [targetStyle]="{ height: '30rem' }"
      (onMoveToSource)="updateFormValue()"
      (onMoveToTarget)="updateFormValue()"
      (onTargetReorder)="updateFormValue()"
      (onMoveAllToSource)="updateFormValue()"
      (onMoveAllToTarget)="updateFormValue()"
      [target]="selectedCategories"
      [source]="bookmarkCategories">
      <ng-template let-category pTemplate="item">
        <div class="flex-1 flex flex-column gap-2">
          <div class="flex align-items-center gap-2">
            <i class="fas fa-layer-group"></i>
            <span>
              {{ category.title }}
            </span>
          </div>
        </div>
      </ng-template>
    </p-pickList>
  }

  <p-divider></p-divider>
  <app-form-footer
    [cancelLevel]="1"
    [showRemoveButton]="
      !!(
        itemToEdit &&
        permissionService.checkThemeRights(itemToEdit._id, 'remove')
      )
    "
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.title) : undefined
    "></app-form-footer>
</form>
